import { Image } from '@round/ui-kit';
import { MicrowaveInfluencerAccountOption } from 'Modules/Advertising/Microwave/useMicrowaveInfluencerAccountsSelect';
import styles from './MicrowaveInfluencerAccountOptionLabel.module.css';
import { ReactComponent as TiktokIcon } from 'assets/icons/platform/TikTok.svg';
import { ReactComponent as InstagramIcon } from 'assets/icons/platform/Instagram.svg';
import { ReactComponent as YoutubeIcon } from 'assets/icons/platform/Youtube.svg';
import { microwave } from '@round/api';

type Props = MicrowaveInfluencerAccountOption & {
    context: 'value' | 'menu';
};

const PlatformIcon = ({ platform }: { platform: microwave.Platform }) => {
    if (platform === 'tiktok') return <TiktokIcon />;
    if (platform === 'instagram') return <InstagramIcon />;
    if (platform === 'youtube') return <YoutubeIcon />;
    return null;
};

const MicrowaveInfluencerAccountOptionLabel = ({
    label,
    platform,
    accountHandle,
    nickname,
    imageUrl,
    context,
}: Props) => {
    const handle = accountHandle ?? nickname ?? label;

    return (
        <div className={styles.container}>
            {context === 'menu' && <Image src={imageUrl} alt={handle} className={styles.image} />}
            <div className={styles.platform}>
                <PlatformIcon platform={platform} />
                <span className={styles.handle}>{handle}</span>
            </div>
        </div>
    );
};

export default MicrowaveInfluencerAccountOptionLabel;
